import React, { useContext, useState, useRef, useEffect, useMemo } from "react";
import { HotelContext } from "../context/hotel";
import { Form, Button, Col, Row, Container } from "react-bootstrap";
import { UserContext } from "../context/user";
import { useItems } from "../hooks/useItems";
import { i18nValue } from '../functions';
import { NavLink } from 'react-router-dom';
import Screen from '../components/Screen';
import { validateCheckOut, checkOut } from '../actions/roomOccupationActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { T, TF } from 'react-translator-component';
import { getCountriesList } from "../configs/getCountriesList";

const CheckOut = (props) => {
  const { sectionsByCode, data: { id: hotelId, code: hotelCode, faqs } } = useContext(HotelContext);
  const { language, RoomOccupation } = useContext(UserContext);
  const [validating, setValidating] = useState(false);
  const [showBillableInfoForm, setShowBillableInfoForm] = useState(false);
  const [billableData, setBillableData] = useState({})
  const [loading, setLoading] = useState(false)
  const [disabledButton, setDisabledButton] = useState(false)
  const [checkOutOk, setCheckOutOk] = useState(false)
  const [errors, setErrors] = useState(false)
  const currentLanguage = language?.slice(0, 2) || "en";
  const sortedCountries = getCountriesList(currentLanguage);
  const inputAddressRef = useRef(null);
  const inputPostalCodeRef = useRef(null);
  const inputCityRef = useRef(null);
  const inputCountryCodeRef = useRef(null);

  // const checkoutState = useMemo(() => {
  //   const r = { hasDebt: false, outValid: false, allowed: false };
  //   setDisabledText(null)
  //   if (RoomOccupation) {
  //     if (RoomOccupation.balance) {
  //       const objBalance = JSON.parse(RoomOccupation.balance)
  //       if (objBalance && objBalance.total !== undefined) {
  //         if (objBalance.total === 0) {
  //           r.hasDebt = true;
  //         } else {
  //           setDisabledText(`Debe cancelar la deuda de ${objBalance.total} para poder hacer CheckOut`)
  //         }
  //       }
  //     }
  //     if (RoomOccupation.end !== "2023-08-18") {   // TODO:::: no acorta el END
  //       r.outValid = false;
  //       setDisabledText(`Su estadía tiene más días por delante... ((( TBD )))... Poner botón para solicitar acortar la estadía?`)
  //     }
  //   }
  //   console.log('1708 - RoomOccupation', RoomOccupation)

  //   console.log('1708 - checkoutState', r)
  //   return r;
  // }, [ RoomOccupation ])

  const validate = () => {
    setValidating(true);
    setDisabledButton(true);
    console.log('VALIDATING...', RoomOccupation.id, hotelId)
    validateCheckOut(RoomOccupation.id, hotelId).then(r => {
      console.log('RRR', r)
      setValidating(false);
      if (r?.status === "allowed") {
        setDisabledButton(false)
        setShowBillableInfoForm(true)
        const data = JSON.parse(r.data)
        if (data.billable_data) {
          setBillableData(data.billable_data)
        }
      } else if (r?.status === "restricted") {
        setErrors(JSON.parse(r.data))
      }


    })
  }

  useEffect(() => {
    validate()
  }, [])

  const Error = ({ error }) => {
    console.log("error", error)

    const showBalance = useMemo(() => {
      return RoomOccupation?.showBalance ?? false;
    }, [RoomOccupation?.showBalance]);

    if (error.type === 'balance-non-zero'  && showBalance) {
      return (
        <>
          <p>{TF('checkout.error-balance', error.value)}</p>
          <p>{T('checkout.error-noShowBalance')}</p>
          <div className="pb-4">
            <NavLink to="../services/service_general">
              <Button>
                {T("checkout.error-departure-button")}
              </Button>
            </NavLink>
          </div>

        </>
      )
    }
    if (error.type === 'balance-non-zero' && !showBalance) {
      return (
        <>
          <p>{T('checkout.error-noShowBalance')}</p>
          <div className="pb-4">
            <NavLink to="../services/service_general">
              <Button>
                {T("checkout.error-departure-button")}
              </Button>
            </NavLink>
          </div>
        </>
      )
    }
    
    return false

  }

  const BillableInfoForm = () => {
    return <Container>
      <Row>
        <Col className="text-center mt-5" style={{ background: "white", border: "1px solid #EEE", borderRadius: 10, padding: "10px 20px" }}>
          <h6>Billing Address</h6>
          <fieldset>
            <p className='font-size-sm text-left text-muted mb-0'>Address</p>
            <Form.Control type={'input'}
              ref={inputAddressRef}
              defaultValue={billableData.address || ''}
              onChange={event => {
                // setBillableData({ ...billableData, address: event.target.value });
              }}
            // }} isInvalid={errors.email} 
            />
            <p className='font-size-sm text-left text-muted mb-0 mt-2'>City</p>
            <Form.Control type={'input'}
              ref={inputCityRef}
              defaultValue={billableData.city || ''}
            // onChange={ event => {
            //   setEmail(event.target.value);
            // }} isInvalid={errors.email} 
            />
            <p className='font-size-sm text-left text-muted mb-0 mt-2'>Postal Code</p>
            <Form.Control type={'input'}
              ref={inputPostalCodeRef}
              defaultValue={billableData.postalCode || ''}
            // onChange={ event => {
            //   setEmail(event.target.value);
            // }} isInvalid={errors.email} 
            />
            <p className='font-size-sm text-left text-muted mb-0'>Country</p>
            <Form.Control as={'select'}
              ref={inputCountryCodeRef}
              defaultValue={billableData.countryCode || ''}
              onChange={event => {
                // setBillableData({ ...billableData, countryCode: event.target.value });
              }}>
              <option value="" selected={billableData.countryCode === '' ? 'selected' : ''}></option>
              {Object.values(sortedCountries).map((val, idx) => {
                return (
                  <option value={val.code} selected={billableData.countryCode === val.code ? 'selected' : ''}>{val.name}</option>
                )
              })}
            </Form.Control>
          </fieldset>
        </Col>
      </Row>
    </Container>
  }

  return (
    <Screen
      section={'checkout'}
      title={'CheckOut'}
    >
      {!validating && !loading && checkOutOk && <Container><Row><Col className="text-center mt-5">
        <div className="text-center mt-5" style={{ background: "white", border: "1px solid #EEE", borderRadius: 10, padding: "10px 20px" }}>
          <span className="font-size-sm d-block mb-3"><FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 80, color: '#28a745', marginTop: -20 }} className="mb-1" /></span>
          <h6 className="text-success mb-2">{T('checkout.success-title')}</h6>
          <NavLink className="btn btn-primary mt-4 mb-2 text-white" style={{ color: 'black' }} to={{ pathname: '/' + hotelCode + '/checkin' }} replace>Continue</NavLink>
        </div></Col></Row></Container>}

      {validating && <div className="text-center mt-5">
        <div className="loading mb-3"><div className="spinner-border"></div></div>
        <h6>{T('checkout.loading-information')}</h6>
      </div>}
      {!checkOutOk && !validating && !loading && showBillableInfoForm && <BillableInfoForm />}
      {loading && <div className="loading text-center mt-5"><div className="spinner-border" role="status"></div></div>}
      {!loading && <div className="mt-2">

        {!validating && !loading && errors && <Container><Row><Col className="text-center mt-5">
          <div className="text-center mt-5" style={{ background: "white", border: "1px solid #EEE", borderRadius: 10, padding: "10px 20px" }}>
            <span className="font-size-sm d-block mb-3"><FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 80, color: '#dc3545', marginTop: -20 }} className="mb-1" /></span>
            <h6 className="text-danger mb-4">{T('checkout.errors-title')}</h6>
            {errors.map(e => (<Error error={e} />))}
          </div></Col></Row></Container>}


      </div>}

      {!validating && !loading && !checkOutOk && !disabledButton && <div className="footer-container">
        <Button
          size={'lg'}
          variant={'primary'}
          type={'button'}
          className="text-uppercase w-100"
          onClick={() => {

            const invoiceData = {
              address: inputAddressRef.current.value.trim(),
              city: inputCityRef.current.value.trim(),
              postalCode: inputPostalCodeRef.current.value.trim(),
              countryCode: inputCountryCodeRef.current.value.trim()
            }

            if (invoiceData.address == '' || invoiceData.city == '' || invoiceData.postalCode == '' || invoiceData.countryCode == '') {
              alert('All data is required')
              return;
            }
            setErrors(null)
            setLoading(true)
            checkOut(RoomOccupation.id, hotelId, invoiceData).then(r => {
              console.log('RRR', r)
              if (r?.status) {
                setTimeout(() => {   // TODO:: parche para que el redireccionado no lo haga a requests... por el stay true/false de la sesion
                  setLoading(false)
                  setCheckOutOk(true)
                }, 4000)
              } else {
                setLoading(false)
                // setError(r.data)
              }
            })
          }}>
          {T('checkout.button')}
        </Button>
      </div>}

    </Screen>
  );
}

export default CheckOut;